import { API_URI_PREFIX } from 'shared/config'

import { Request, RequestMethod } from './shared-request'

const makeHttp = (urlPrefix = '') => {
    const request = Request({
        urlPrefix
    })
    const ajaxGet: RequestMethod['get'] = (...args) => request.get(...args)

    const ajaxPost: RequestMethod['post'] = (...args) => request.post(...args)

    const ajaxPut: RequestMethod['put'] = (...args) => request.put(...args)

    const ajaxDelete: RequestMethod['delete'] = (...args) => request.delete(...args)

    const addRequestInterceptor: RequestMethod['addRequestInterceptor'] = (...args) =>
        request.addRequestInterceptor(...args)

    return {
        get: ajaxGet,
        post: ajaxPost,
        put: ajaxPut,
        delete: ajaxDelete,
        addRequestInterceptor
    }
}

export const apiHttp = makeHttp(API_URI_PREFIX)
